<template>
    <div id="add-new-appointment">
        <loading :dspin="displayLoading"></loading>
        <div v-show="showForm && !displayLoading">
            <h6 class="flow-blue-color w3-left zero-left font-weight-bold w-100pc flow-margin-top-3-pct">
                {{ $t("addNewAppointment") }}

                <!--<span class="w3-right w3-margin-right">-->
                    <!--<i class="fa fa-save flow-green-active-color cursor-pointer w3-ripple zero w3-xlarge w3-margin-right"-->
                       <!--@click="saveAppointment"></i>-->
                    <!--<i class="fa fa-times w3-text-red cursor-pointer w3-ripple zero w3-xlarge"-->
                           <!--@click="closeForm"></i>-->
                <!--</span>-->
            </h6>

            <form class="flow-form-cum-panel w3-col flow-margin-bottom zero-left">
                <div class="w3-container zero-top zero-left">
                    <p v-bind:class="physicians.length < 1 ? 'w3-disabled' : ''"
                       class="w3-col w-45pc flow-form-inline-input zero-left w3-margin-right">
                        <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("physicians") }}</label>
                        <flow-select :items="physicians"
                                     :valueKey="'name'"
                                     :valueKeyIndex="'id'"
                                     :callback="selectPhysician">
                        </flow-select>
                    </p>
                    <p v-bind:class="groups.length < 1 ? 'w3-disabled' : ''"
                       class="w3-col w-45pc flow-form-inline-input zero-left zero-right">
                        <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("appointmentTypes") }}</label>
                        <flow-select :items="groups"
                                     :valueKey="'displayName'"
                                     :valueKeyIndex="'id'"
                                     :callback="selectGroup">

                        </flow-select>
                    </p>
                </div>


                <div class="w3-container zero-top zero-left">
                    <p class="w3-col w-45pc flow-form-inline-input w3-left zero-left">
                        <label class="w3-left w3-left-align flow-blue-color flow-padding-bottom w-100pc">{{ $t("time") }}</label>
                        <input class="w3-input w-90pc w3-show-inline-block time-picker-trigger" type="text"
                               v-bind:placeholder="$t('select.time')"
                               v-bind:class="timeError ? 'error' : ''"
                               @click="openTimePicker = !openTimePicker"
                               v-bind:value="appointmentTime.val"/>
                        <i class="far fa-clock w3-large flow-blue-color flow-padding-left flow-padding-top cursor-pointer w3-ripple time-picker-trigger"
                           @click="openTimePicker = !openTimePicker"
                           :title="$t('openTimePicker')"></i>
                        <span class="w3-text-red"> {{ timeError }} </span>
                    </p>
                    <p class="w3-col w-45pc flow-form-inline-input time-picker-container">
                        <time-picker v-if="openTimePicker"
                                     class="flow-card w3-animate-opacity"
                                     :preSelected="appointmentTime"
                                     :onChange="onChange"
                                     :onClose="()=>{openTimePicker = false;}">
                        </time-picker>
                    </p>
                </div>

                <div class="flow-btn-checkbox-group flow-padding-top flow-form-inline-input w-100pc zero-left zero-top"
                     v-if="lastAppointment">
                    <div class="w3-container w3-btn cursor-pointer w3-ripple flow-btn-checkbox w3-animate-opacity w3-left w-100pc zero-left zero-top"
                         v-bind:class="isReturning ? 'active' : 'inactive'"
                         @click="changeReturning">
                        <div class="w3-col flow-btn-checkbox-icon zero-right" :class="{'w-2pc': !isSideCard}">
                            <i class="fa  w3-left"></i>
                        </div>
                        <div class="w3-col flow-btn-checkbox-label zero-left">
                            <span class="zero-left" v-if="lastAppointment.physician">{{$t("returnTo", {"physician": lastAppointment.physician.name})}}</span>
                            <span class="zero-left" v-else>{{$t("returnTo", {"physician": lastAppointment.consultationGroup.displayName})}}</span>
                        </div>
                    </div>
                </div>

                <div class="w3-container zero-left">
                    <button class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-left w3-margin-right w3-margin-top w3-large"
                            @click.prevent="saveAppointment">
                        <i class="fa fa-save flow-green-active-color">
                            <span><b class="flow-margin-left">{{$t('save')}}</b></span>
                        </i>
                    </button>

                    <button class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-left w3-margin-top w3-large"
                            @click.prevent="closeForm">
                        <i class="fa fa-arrow-left w3-text-red">
                            <span><b class="flow-margin-left">{{$t('back')}}</b></span>
                        </i>
                    </button>
                </div>

            </form>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import FlowSelect from "../common/FlowSelect";
    import TimePicker from "../common/TimePicker";
    import Loading from "../common/Loading";
    import {EventBus} from "../../main";

    let frc = Vue.prototype.$frc;

    export default {
        name: "NewAppointment",
        props: ["openAddAppointment", "patientId", "lastAppointment", "callback", "isSideCard"],
        components : {FlowSelect, TimePicker, Loading},
        data: function() {
            return{
                displayLoading: false,
                showForm: null,
                groups: [],
                openTimePicker: false,
                physicians: [],
                appointmentTime: '',
                timeError: '',
                isReturning: false,
                returningId: null,
                groupId: '',
                physicianId: ''
            }
        },
        mounted() {
            this.getConsultationGroups();
            this.getPhysicians();
        },
        watch: {
            openAddAppointment () {
                this.showForm = this.openAddAppointment;
                this.isReturning = false;
                this.appointmentTime = '';
                this.timeError = '';
                if (this.groups) {
                    Vue.sortByKey(this.groups, 'displayName');

                } else {
                    this.getConsultationGroups();
                }

                if (this.physicians) {
                    Vue.sortByKey(this.physicians, 'name');
                } else {
                    this.getPhysicians();
                }
            }
        },
        methods: {
            getConsultationGroups() {
                const wardId = Vue.prototype.$currentWard.id;
                const app = this;
                frc.getConsultationGroupsInWard(wardId).then(function (res) {
                    app.groups = res.data;
                }).catch(function (ex) {
                    console.log(ex);
                });
            },
            getPhysicians() {
                const wardId = Vue.prototype.$currentWard.id;
                const app = this;
                frc.getPhysiciansInWard(wardId).then(function (res) {
                    app.physicians = res.data;
                }).catch(function (ex) {
                    console.log(ex);
                });
            },
            closeForm () {
                this.callback(false);
            },
            onChange(time) {
                this.appointmentTime = time;
            },
            changeReturning() {
                this.isReturning = ! this.isReturning
            },
            selectPhysician(physician) {
                if (physician) {
                    this.physicianId = physician.id;
                }
            },
            selectGroup(group) {
                if (!group) {
                    return;
                }
                this.groupId = group.id;
            },
            saveAppointment: function () {
                var ward = Vue.prototype.$currentWard.id;
                this.displayLoading = true;
                this.timeError = '';
                var app = this;

                if(!app.appointmentTime) {
                    app.displayLoading = false;
                    app.timeError = app.$t("INVALID_TIME");
                    return;
                }

                if (app.isReturning && app.lastAppointment) {
                    app.returningId = app.lastAppointment.id;
                }

                frc.addNewAppointment(ward, app.patientId, {
                    appointmentTime: app.appointmentTime.val,
                    physicianId: app.physicianId,
                    groupId: app.groupId,
                    returnToAppointmentId: app.returningId
                }).then(function () {
                    app.displayLoading = false;
                    app.returningId = null;
                    app.callback(true);
                    Vue.notifySuccess({title: app.$t("appointmentSuccessfullyCreated")});
                    EventBus.$emit("appointmentAdded", app.patientId);
                }).catch(function (ex) {
                    app.displayLoading = false;
                    console.log(ex);

                    if (ex.restCodes.includes("INVALID_TIME")) {
                        app.timeError = app.$t("INVALID_TIME");
                    }
                })
            }

        }
    }
</script>